/* The six modules: shortcut order, band, glyph, dimensions, sub-views (spec section 5). */
import { band } from '../tokens/semantic';
import type { GlyphName } from '../glyphs/glyphs';

export type ModuleId = 'core' | 'lens' | 'pulse' | 'impact' | 'confluence' | 'memory';

export interface ModuleDef {
  id: ModuleId;
  key: string;
  name: string;
  band: string;
  glyph: GlyphName;
  /** the market dimensions it carries, as written on screen */
  dims: string;
  subs: { id: string; name: string }[];
}

export const MODULES: ModuleDef[] = [
  { id: 'core', key: '1', name: 'Core', band: band.core, glyph: 'core', dims: 'Price', subs: [] },
  {
    id: 'lens', key: '2', name: 'Lens', band: band.lens, glyph: 'lens', dims: 'Options, flow (est.), liquidity (proxy)',
    subs: [{ id: 'strikes', name: 'Strikes' }, { id: 'expiries', name: 'Expiries' }, { id: 'greeks', name: 'Greeks' }],
  },
  {
    id: 'pulse', key: '3', name: 'Pulse', band: band.pulse, glyph: 'pulse', dims: 'Volatility, volume (options)',
    subs: [{ id: 'vol', name: 'Volatility' }, { id: 'surface', name: 'IV surface' }],
  },
  {
    id: 'impact', key: '4', name: 'Impact', band: band.impact, glyph: 'impact', dims: 'Catalysts',
    subs: [{ id: 'releases', name: 'Releases' }, { id: 'news', name: 'News and positioning' }],
  },
  {
    id: 'confluence', key: '5', name: 'Confluence', band: band.confluence, glyph: 'confluence', dims: 'All dimensions recombined',
    subs: [{ id: 'gauges', name: 'Gauges' }, { id: 'compass', name: 'Day candle' }],
  },
  { id: 'memory', key: '6', name: 'Memory', band: band.memory, glyph: 'memory', dims: 'Time', subs: [] },
];

export const MODULE = Object.fromEntries(MODULES.map(m => [m.id, m])) as Record<ModuleId, ModuleDef>;
